export function UsagePageSkeleton() {
  return (
    <div className="usage-page is-loading usage-page-skeleton" aria-busy="true">
      <div className="page-loading-bar" aria-hidden="true" />
      <div className="usage-page-actions">
        <span className="skeleton skeleton-action" />
      </div>
      <div className="summary-grid">
        {[0, 1, 2].map((index) => (
          <div className="stat-box" key={index}>
            <span className="skeleton skeleton-line usage-stat-label-skeleton" />
            <UsageMetricSkeleton />
            <span className="skeleton skeleton-line usage-stat-sub-skeleton" />
          </div>
        ))}
      </div>
      <div className="usage-filter-card usage-filter-skeleton" id="usageFilterStrip">
        <div className="usage-filter-toolbar">
          <span className="skeleton usage-filter-toggle-skeleton" />
          <div className="usage-filter-chips">
            {[0, 1].map((index) => (
              <span className="skeleton usage-filter-chip-skeleton" key={index} />
            ))}
          </div>
        </div>
      </div>
      <section className="usage-panel">
        <div className="usage-panel-head">
          <div>
            <span className="skeleton skeleton-line skeleton-heading" />
            <span className="skeleton skeleton-line skeleton-copy" />
          </div>
        </div>
        <div className="usage-chart-shell">
          <div className="chart-container">
            <UsageChartSkeleton />
          </div>
        </div>
      </section>
      <section className="usage-panel">
        <span className="skeleton skeleton-line skeleton-heading" />
        <ModelBreakdownSkeleton />
      </section>
    </div>
  );
}

export function UsageMetricSkeleton() {
  return <span className="skeleton usage-metric-skeleton" aria-hidden="true" />;
}

export function UsageChartSkeleton() {
  const heights = [46, 72, 38, 84, 58, 92, 66];
  return (
    <div className="usage-chart-skeleton" aria-hidden="true">
      {heights.map((height, index) => (
        <div className="usage-chart-skeleton-group" key={index}>
          <span className="skeleton usage-chart-skeleton-bar" style={{ height: `${height}%` }} />
          <span className="skeleton usage-chart-skeleton-label" />
        </div>
      ))}
    </div>
  );
}

export function ModelBreakdownSkeleton() {
  return (
    <div className="model-breakdown-skeleton" aria-hidden="true">
      {[0, 1, 2, 3, 4].map((index) => (
        <div className="hbar-row model-breakdown-skeleton-row" key={index}>
          <span className="skeleton skeleton-line hbar-name-skeleton" />
          <span className="skeleton hbar-track-skeleton" />
          <span className="skeleton skeleton-line hbar-cost-skeleton" />
        </div>
      ))}
    </div>
  );
}
